// A code in a booking link (?code=AUTUMN20): read it the moment the page
// loads (the page's own deep-link handlers wipe the address bar later), and
// remember it for this salon for 14 days, so a client who taps a post, looks
// around and comes back still has it. Per salon, so a code for one salon is
// never tried on another's booking.
import { cleanCode, looksLikeGiftCard, MIN_LEN } from '../data/codes';

const KEY = 'beu-booking-code';
export const WINDOW_MS = 14 * 24 * 60 * 60 * 1000;

const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) { return {}; } };
const write = (v) => { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) { /* private mode: not remembered */ } };

/** The code on this page's address, cleaned, or null. */
export function codeFromUrl(search = (typeof window !== 'undefined' ? window.location.search : '')) {
  let raw = null;
  try { raw = new URLSearchParams(search).get('code'); } catch (e) { return null; }
  if (!raw || looksLikeGiftCard(raw)) return null;
  const c = cleanCode(raw);
  return c.length >= MIN_LEN ? c : null;
}

export function rememberCode(salonId, code, now = Date.now()) {
  if (!salonId || !code) return;
  const all = read();
  Object.keys(all).forEach((k) => { if (!all[k] || !(now - all[k].at < WINDOW_MS)) delete all[k]; });
  all[String(salonId)] = { code: cleanCode(code), at: now };
  write(all);
}

export function rememberedCode(salonId, now = Date.now()) {
  const hit = read()[String(salonId || '')];
  if (!hit || !hit.code || !(now - hit.at < WINDOW_MS) || hit.at > now + 60000) return null;
  return hit.code;
}

export function forgetCode(salonId) {
  const all = read();
  if (all[String(salonId)]) {
    delete all[String(salonId)];
    write(all);
  }
}
